export interface StatusField {
  code?: number;
  key?: string;
  name?: string;
  date?: string;
  color?: string;
  note?: string;
}

export function createStatusField(data?: Partial<StatusField>): StatusField {
  return {
    code: data?.code,
    key: data?.key,
    name: data?.name,
    date: data?.date,
    color: data?.color,
    note: data?.note
  };
}
